import getStore from '../store';
import { processCalendarViewType } from '../utils/processCalendarViewType';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';

// TODO: VSO #93977 Rationalize module routing when board view type is explicitly specified for surface-only routes
// Once the above is addressed, we should remove the `forceSurfaceViewType` shim
export function getSelectedViewType(forceSurfaceViewType?: boolean): CalendarViewTypeEnum {
    return processCalendarViewType(getStore().selectedViewType, forceSurfaceViewType);
}
